import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RequestProvider } from '../providers/request/request';
import { AuthProvider } from '../providers/auth/auth';
import { LoginPage } from "../pages/login/login";
import { LogoutPage } from "../pages/logout/logout";
import { SalesOrdersPage } from "../pages/sales-orders/sales-orders";
import { PartOverviewPage } from "../pages/part-overview/part-overview";
import { WorkReportsPage } from "../pages/work-reports/work-reports";
import { WorkReportPage } from "../pages/work-report/work-report";
import { SaleOrderProvider } from '../providers/sale-order/sale-order';
import { SaleOrderPage } from "../pages/sale-order/sale-order";
import { PartDetailPage } from "../pages/part-detail/part-detail";
import { WorkReportProvider } from '../providers/work-report/work-report';
import { CreateWorkReportPage } from "../pages/create-work-report/create-work-report";
import { WorkReportEditPartPage } from "../pages/work-report-edit-part/work-report-edit-part";
import { ValidationProvider } from '../providers/validation/validation';
import { ToastProvider } from '../providers/toast/toast';
import {WorkReportEditPartListPage} from "../pages/work-report-edit-part-list/work-report-edit-part-list";
import { VersionProvider } from '../providers/version/version';
import {SearchListItemPage} from "../pages/search-list-item/search-list-item";
import { ErrorListProvider } from '../providers/error-list/error-list';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import {LoginQrCodePage} from "../pages/login-qr-code/login-qr-code";
import {PhotoLibrary} from "@ionic-native/photo-library";
import { VehicleProvider } from '../providers/vehicle/vehicle';
import {VehiclePage} from "../pages/vehicle/vehicle";
import {BarcodeScanner} from '@ionic-native/barcode-scanner';
import {Camera} from "@ionic-native/camera";
import {FileOpener} from "@ionic-native/file-opener";
import {File} from "@ionic-native/file";
import {DocumentViewer} from "@ionic-native/document-viewer";
import { ConfigProvider } from '../providers/config/config';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    LogoutPage,
    SalesOrdersPage,
    SaleOrderPage,
    PartOverviewPage,
    PartDetailPage,
    WorkReportsPage,
    WorkReportPage,
    CreateWorkReportPage,
    WorkReportEditPartPage,
    WorkReportEditPartListPage,
    SearchListItemPage,
    LoginQrCodePage,
    VehiclePage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    NgxQRCodeModule,
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    LogoutPage,
    SalesOrdersPage,
    SaleOrderPage,
    PartOverviewPage,
    PartDetailPage,
    WorkReportsPage,
    WorkReportPage,
    CreateWorkReportPage,
    WorkReportEditPartPage,
    WorkReportEditPartListPage,
    SearchListItemPage,
    LoginQrCodePage,
    VehiclePage
  ],
  providers: [
    BarcodeScanner,
    Camera,
    File,
    FileOpener,
    DocumentViewer,
    PhotoLibrary,
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    RequestProvider,
    AuthProvider,
    SaleOrderProvider,
    WorkReportProvider,
    ValidationProvider,
    ToastProvider,
    VersionProvider,
    ErrorListProvider,
    VehicleProvider,
    ConfigProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts